import surveysLocale from './en.json'

const en = {
  surveys: surveysLocale,
}

export default en
